module.exports = __webpack_public_path__ + "img/西南大学-300x283.c64a0521.jpg";